/*
    Главная страница
*/

import { throttle } from './ThrottleDebounce';

let scrollPoints;
let $scrolledWraps = $('.js-scrolled-wrap');
const $notesSlider = $('.js-notes-slider');

new Swiper('.js-main-news-slider', {
    slidesPerView: 2,
    navigation: {
        nextEl: '.js-main-news-slider-next',
        prevEl: '.js-main-news-slider-prev',
    },
    breakpoints: {
        760: {
            slidesPerView: 1
        }
    }
});


if ($notesSlider.length) {
     const mobileConfig = {
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerColumn: 1,
        pagination: {
            el: '.js-notes-slider-pagination',
            type: 'fraction',
        },
        navigation: {
            prevEl: '.js-notes-slider-prev',
            nextEl: '.js-notes-slider-next',
        }
    };

    const desktopConfig = {
        spaceBetween: 0,
        slidesPerView: 2,
        slidesPerColumn: 2,
        pagination: {
            el: '.js-notes-slider-pagination',
            type: 'fraction',
        },
        navigation: {
            prevEl: '.js-notes-slider-prev',
            nextEl: '.js-notes-slider-next',
        }
    };

    new Swiper('.js-notes-slider', App.mobile && App.W.outerWidth() < 767 ? mobileConfig : desktopConfig);
}

/*function horScroll() {
    $.jInvertScroll(['.js-horizontal-scroll']);
}*/

function tabletScroll() {
    //const scrollTop = App.H.scrollTop();
    const scrollTop = App.H.scrollTop() + $('.js-header').outerHeight();

    for (let i = 0; i < scrollPoints.length; i++) {
        if (scrollTop > scrollPoints[i] && scrollTop < scrollPoints[i] + $scrolledWraps.eq(i).outerHeight()) {
            $scrolledWraps.eq(i)
                .addClass('_fixed')
                .removeClass('_bottom');
        }

        if (scrollTop < scrollPoints[i]) {
            $scrolledWraps.eq(i)
                .removeClass('_fixed')
                .removeClass('_bottom');
        }

        if (scrollTop > scrollPoints[i] + $scrolledWraps.eq(i).outerHeight() - $scrolledWraps.eq(i).find('.js-scrolled-block').outerHeight()) {
            $scrolledWraps.eq(i)
                .removeClass('_fixed')
                .addClass('_bottom');
        }
    }

}

//if (App.H.hasClass('page-main') && !App.mobile && App.H.outerWidth() > 1024) {
if (!App.mobile && App.H.outerWidth() > 1024) {
    /*setTimeout(function () {
        horScroll();
    }, 2000);*/
    //horScroll();

    //App.W.on('resize', throttle(horScroll, 100));
} else {
    $('.js-append-mobile-wrap').each(function (index, el) {
        let appended = $(el).siblings('.js-append-mobile-el');

        //console.log('test', index);

        $(el).find('>div').last().after(appended);
    });
}

if (App.mobile && App.H.outerWidth() <= 1024 && App.H.outerWidth() >= 768) {
    scrollPoints = [];

    $scrolledWraps.each(function (index, el) {
        scrollPoints.push($(el).offset().top);
    });


    App.W.on('scroll', throttle(tabletScroll, 100));
}

/*$(document).ready(function(){
    $('html, body').animate({scrollTop: 0}, 20);
});*/





// WEBPACK FOOTER //
// ./_src/js/modules/PageMain.js